import React from 'react'
import { SectionHeader, SectionWrap, ButtonSecoundry } from '../../Components';
import FieldsShort from '../FieldsShort/FieldsShort';
import './Property.css';
import { useTranslation } from 'react-i18next';


function Property() {
    const { t, i18n } = useTranslation();
  
  return (
    <>
    <div className='fieldsPageContainer'>
        <div className='headPage property'>
        </div>
        <div className='containerNew'> 
            <SectionWrap>
            <SectionHeader title={t('fieldsShort2')} disc={t('fieldsPageSpan')} />
            <div className='fieldInfo'>
                <p>{t('fieldsPage2p1')}</p>
                <span>{t('fieldsPage2Span1')}</span>
                <p>{t('fieldsPage2p2')}</p>
                <span>{t('fieldsPage2Span2')}</span>
                <ul className='listProperty'>
                    <li>{t('fieldsPage2Li1')}</li>
                    <li>{t('fieldsPage2Li2')}</li>
                    <li>{t('fieldsPage2Li3')}</li>
                    <li>{t('fieldsPage2Li4')}</li>
                    <li>{t('fieldsPage2Li5')}</li>
                </ul>
                <span>{t('fieldsPage2Span3')}</span>
                <p>{t('fieldsPage2p3')}</p>
                <p>{t('fieldsPage2p4')}</p>
            </div>
            <ButtonSecoundry className='askBtnFields' href='/askConsults'>{t('askYourConsult')}</ButtonSecoundry>
        </SectionWrap>
        </div>
        <FieldsShort />
    </div>
    </>
  )
}

export default Property